import { NextPage } from 'next';
import { GetServerSideProps } from 'next';
import AuthorDetail from '@/components/screens/author-detail/AuthorDetail';
import { API_URL } from '@/helpers/variables';
import { IAuthorDetail } from '@/interfaces/authorDetail.interface';

import { ISimilarAuthors } from '@/interfaces/similarAuthors';

interface IAuthorDetailPageDynamic {
  books: IAuthorDetail;
  similarAuthors: ISimilarAuthors;
}

const AuthorDetailPageDynamic: NextPage<IAuthorDetailPageDynamic> = ({ books, similarAuthors }) => {
  return <AuthorDetail books={books} similarAuthors={similarAuthors} />;
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { id } = context.query;

  const res = await fetch(`${API_URL}satellite/author/info/${id}?page=1&page_size=20`);
  const books = await res.json();

  // Check Fetched Data Error
  if (!books.books?.total_count) {
    return {
      notFound: true,
    };
  }

  const [similarAuthorsRes] = await Promise.all([fetch(`${API_URL}satellite/similar/author/${books.alias}`)]);
  const [similarAuthors] = await Promise.all([similarAuthorsRes.json()]);

  return {
    props: {
      books,

      similarAuthors,
    },
  };
};

export default AuthorDetailPageDynamic;
